module.exports = __webpack_public_path__ + "static/media/jayco1.90be76fc.JPG";